module.exports = __webpack_public_path__ + "static/media/chat-line.19119f3c.mp3";